if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer) return;

        const initialMedia = this.elements.viewer.querySelector(
          '.is-active[data-media-id]'
        );

        if (initialMedia) {
          this.filterColorMedia(initialMedia.dataset.mediaId);
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            const button = mediaToSwitch.querySelector('button');
            if (!button) return;

            button.addEventListener(
              'click',
              this.setActiveMedia.bind(
                this,
                mediaToSwitch.dataset.target,
                false
              )
            );
          });

        if (
          this.dataset.desktopLayout?.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const mediaId = event.detail.currentElement?.dataset.mediaId;
        if (!mediaId || !this.elements.thumbnails) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');
        this.filterColorMedia(activeMedia.dataset.mediaId);

        if (prepend) {
          if (activeMedia.parentElement.firstElementChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${activeMedia.dataset.mediaId}"]`
              );

            if (
              activeThumbnail &&
              activeThumbnail.parentElement.firstElementChild !==
                activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }

          if (this.elements.thumbnails?.slider) {
            this.elements.thumbnails.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }

          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;

          const top = activeMediaRect.top + window.scrollY;

          window.scrollTo({
            top,
            behavior: 'smooth',
          });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${activeMedia.dataset.mediaId}"]`
          );

        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset.mediaPosition
          );
        }
      }

      filterColorMedia(mediaId) {
        if (this.dataset.productId !== '8308193427645') return;

        const navyIds = [
          '31394509488317',
          '31394509521085',
        ];

        const blackIds = [
          '47445511209149',
          '47445511176381',
        ];

        const commonId = '31232848298173';
        const selectedId = String(mediaId).split('-').pop();

        if (navyIds.includes(selectedId)) {
          this.currentColorMediaIds = navyIds;
        } else if (blackIds.includes(selectedId)) {
          this.currentColorMediaIds = blackIds;
        }

        if (!this.currentColorMediaIds) return;

        if (blackIds.includes(selectedId)) {
          const list = this.elements.viewer.querySelector('ul');
          const otherBlackId = blackIds.find(
            (id) => id !== selectedId
          );

          const commonMedia = list?.querySelector(
            `li[data-media-id$="-${commonId}"]`
          );

          const otherBlackMedia = list?.querySelector(
            `li[data-media-id$="-${otherBlackId}"]`
          );

          if (commonMedia && otherBlackMedia) {
            list.append(otherBlackMedia, commonMedia);
          }
        }

        const visibleIds = new Set([
          ...this.currentColorMediaIds,
          commonId,
        ]);

        this.elements.viewer
          .querySelectorAll('li[data-media-id]')
          .forEach((item) => {
            const id = item.dataset.mediaId.split('-').pop();

            if (visibleIds.has(id)) {
              item.style.removeProperty('display');
            } else {
              item.style.setProperty(
                'display',
                'none',
                'important'
              );
            }
          });

        this.elements.thumbnails
          ?.querySelectorAll('[data-target]')
          .forEach((item) => {
            const id = item.dataset.target.split('-').pop();

            if (visibleIds.has(id)) {
              item.style.removeProperty('display');
            } else {
              item.style.setProperty(
                'display',
                'none',
                'important'
              );
            }
          });

        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages();
        }

        if (this.elements.thumbnails?.slider) {
          this.elements.thumbnails.resetPages();
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {
            element.removeAttribute('aria-current');
          });

        thumbnail
          .querySelector('button')
          ?.setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          return;
        }

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image || !this.elements.liveRegion) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia =
          activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}
